<script setup lang="ts">
import { type DividerVariants } from '@/components/lib/GwDivider/gwDividerVariants'

export interface DividerProps {
  variant: DividerVariants
}

defineProps<DividerProps>()
</script>

<template>
  <div :class="variant" />
</template>

<style lang="scss" scoped>
.divider_horizontal {
  width: 100%;
  background: var(--app-divider-clr);
  height: var(--app-divider-height);
}
.divider_vertical {
  height: 100%;
  background: var(--app-divider-clr);
  width: var(--app-divider-height);
}
</style>
